import { createDeleteEndpoint } from '@sonar-software/sonar-http';

export type DeleteInitiativesUnlinkJiraRequest = {
	customerId: number;
	initiativeId: number;
	issueKey: string;
};

export const deleteInitiativesUnlinkJira = createDeleteEndpoint<DeleteInitiativesUnlinkJiraRequest>(
	({ initiativeId }) => `/api/v3/initiatives/${initiativeId}/unlink-jira`,
	{
		requestTransform: ({ initiativeId, ...rest }) => rest
	}
);
